const POST_LOGIN_REDIRECT_KEY = "gitlab-dash-post-login-redirect";

const isInternalPath = (value) =>
	typeof value === "string" &&
	value.startsWith("/") &&
	!value.startsWith("//") &&
	!value.includes("://");

export const getLocationPath = (location) =>
	`${location.pathname}${location.search}${location.hash}`;

export const rememberPostLoginRedirect = (location) => {
	try {
		const path = getLocationPath(location);
		if (isInternalPath(path)) {
			sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
		}
	} catch (error) {
		console.error("Failed to remember post-login redirect:", error);
	}
};

export const takePostLoginRedirect = (fallback = "/") => {
	try {
		const savedPath = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
		sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
		return isInternalPath(savedPath) ? savedPath : fallback;
	} catch (error) {
		console.error("Failed to read post-login redirect:", error);
		return fallback;
	}
};
